import dateFormat from 'dateformat'
import { camera } from '@/services/map-service'
import {
  addTelementryOp,
  PanZoomOp,
  startTelemetry,
} from '@/services/telemetry-service'

/**
 * *(AI-generated)*
 * Samples map move-end events and sends pan/zoom telemetry at a 25% rate.
 */
export const moveEnd = () => {
  // Sample 25% of the time.
  // Don't caputure telemetry in test environments.
  const sampleRate = 0.25
  const isSample = Math.random() < sampleRate
  if (!isSample) {
    return
  }

  startTelemetry()
  sendPanZoomEvent()
}

/**
 * Adds a pan/zoom event to the telemetry service.  Location for the pan/zoom
 * is derived from the visible center of the camera.
 */
export const sendPanZoomEvent = () => {
  const { visibleCenter } = camera()
  if (!visibleCenter) {
    return
  }

  const { longitude, latitude, height } = visibleCenter
  const timestamp = dateFormat(new Date(), 'isoUtcDateTime')

  const op = new PanZoomOp(
    longitude.toFixed(5),
    latitude.toFixed(5),
    height.toFixed(1),
    timestamp
  )
  addTelementryOp(op)
}
